import { render, staticRenderFns } from "./SpammersList.vue?vue&type=template&id=5d060508&scoped=true&"
import script from "./SpammersList.vue?vue&type=script&lang=js&"
export * from "./SpammersList.vue?vue&type=script&lang=js&"
import style0 from "./SpammersList.vue?vue&type=style&index=0&id=5d060508&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d060508",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5d060508')) {
      api.createRecord('5d060508', component.options)
    } else {
      api.reload('5d060508', component.options)
    }
    module.hot.accept("./SpammersList.vue?vue&type=template&id=5d060508&scoped=true&", function () {
      api.rerender('5d060508', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/leads/SpammersList.vue"
export default component.exports